// extracted by mini-css-extract-plugin
export default {"headerNavItem":"HeaderNavItem_headerNavItem__n8sIL","headerNavImage":"HeaderNavItem_headerNavImage__f0yX9","headerNavText":"HeaderNavItem_headerNavText__FSB8L"};